function getLiveStreamUrl() {
  if (process.env.REACT_APP_LIVESTREAM_URL) {
    return process.env.REACT_APP_LIVESTREAM_URL;
  } else {
    return `${window.location.protocol}//${window.location.host}`;
  }
}

export default getLiveStreamUrl;